import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

interface INegotiationGtmData {
    event: "negotiation";
    event_action: "view" | "interaction" | "apply";
    event_label?: number;
    event_category?: number;
    event_category2?: number;
}

/**
 * Track negotiation modal view event
 */
export const hitNegotiationView = () => {
    const gtmData: INegotiationGtmData = {
        event: "negotiation",
        event_action: "view"
    };

    hitGoogleTagManager(gtmData);
};

/**
 * Track negotiation slider interaction event
 * Should be called only once per page load
 */
export const hitNegotiationInteraction = () => {
    const gtmData: INegotiationGtmData = {
        event: "negotiation",
        event_action: "interaction"
    };

    hitGoogleTagManager(gtmData);
};

/**
 * Track negotiation apply event (when user clicks "Negocjuj cenę")
 * @param proposedPrice - The price proposed by the user
 * @param regularPrice - The regular/offer price
 */
export const hitNegotiationApply = (proposedPrice: number, regularPrice: number) => {
    if (proposedPrice <= 0 || regularPrice <= 0) return;

    const priceDifferencePercent = Math.round(((proposedPrice - regularPrice) / regularPrice) * 100);

    const gtmData: INegotiationGtmData = {
        event: "negotiation",
        event_action: "apply",
        event_label: proposedPrice,
        event_category: regularPrice,
        event_category2: priceDifferencePercent
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

interface INegotiationGtmData {
    event: "negotiation";
    event_action: "view" | "interaction" | "apply";
    event_label?: number;
    event_category?: number;
    event_category2?: number;
}

/**
 * Track negotiation modal view event
 */
export const hitNegotiationView = () => {
    const gtmData: INegotiationGtmData = {
        event: "negotiation",
        event_action: "view"
    };

    hitGoogleTagManager(gtmData);
};

/**
 * Track negotiation slider interaction event
 * Should be called only once per page load
 */
export const hitNegotiationInteraction = () => {
    const gtmData: INegotiationGtmData = {
        event: "negotiation",
        event_action: "interaction"
    };

    hitGoogleTagManager(gtmData);
};

/**
 * Track negotiation apply event (when user clicks "Negocjuj cenę")
 * @param proposedPrice - The price proposed by the user
 * @param regularPrice - The regular/offer price
 */
export const hitNegotiationApply = (proposedPrice: number, regularPrice: number) => {
    if (proposedPrice <= 0 || regularPrice <= 0) return;

    const priceDifferencePercent = Math.round(((proposedPrice - regularPrice) / regularPrice) * 100);

    const gtmData: INegotiationGtmData = {
        event: "negotiation",
        event_action: "apply",
        event_label: proposedPrice,
        event_category: regularPrice,
        event_category2: priceDifferencePercent
    };

    hitGoogleTagManager(gtmData);
};
